import React from "react";

function BuildARobust() {
  return (
    <>
      <div
        className="about-style-three-area default-padding bg-gray bg-cover"
        style={{ background: "url(assets/img/shape/banner-16.html)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h4 className="sub-title">AI writing assistant</h4>
              <h2 className="title split-text-right split-text-in-right">
                Order Book DEX Development by Xeer Technology
              </h2>
              <h3>
                Build a Robust Decentralized Trading Platform with Xeer
                Technology
              </h3>
              <p>
                At Xeer Technology, we specialize in developing high-performance
                Order Book Decentralized Exchanges (DEXs) that combine the best
                features of traditional trading systems with the advantages of
                blockchain technology. Our custom Order Book DEX solutions
                provide users with a familiar trading experience while ensuring
                security, transparency, and decentralization.
              </p>
              <a className="btn btn-style-one" href="#">
                Know more
              </a>
            </div>
            <div className="col-lg-6">
              <div className="about-style-three-thumb">
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/dashboard-4.jpg"
                  alt="Image Not Found"
                />
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/1.gif"
                  alt="Image Not Found"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BuildARobust;
